import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/userInfo/Login')
  },
  {
    path: '*', //未定义页面均跳转404
    name: '404',
    component: () => import('../views/exception/404.vue')
  },
  {
    path: '/Home',
    name: 'Home',
    redirect: '/index',
    component: Home,
    children: [
      //主页
      {
        path: '/index',
        name: 'index',
        meta: { title: '主页' },
        component: () => import('../views/index')
      },
      // 个人信息
      {
        path: '/userinfo',
        name: 'userinfo',
        meta: { title: '个人信息' },
        redirect: '/userinfo/basicinfomation',
        component: () => import('../views/userInfo/personal'),
        children: [
          {
            path: '/userinfo/basicinfomation',
            name: '基本信息',
            meta: { title: '基本信息' },
            component: () => import('../views/userInfo/basicinfomation')
          },
          {
            path: '/userinfo/contact',
            name: '联系方式',
            meta: { title: '联系方式' },
            component: () => import('../views/userInfo/contact')
          },
          {
            path: '/userinfo/changePW',
            name: '修改密码',
            meta: { title: '修改密码' },
            component: () => import('../views/userInfo/changePW')
          }
        ]
      },
      //系统管理
      {
        path: '/system/dataDictionary',
        name: 'system',
        meta: { title: '系统设置' },
        redirect: '/system/dataDictionary',
        component: RouteView,
        children: [
          {
            path: '/system/dataDictionary',
            name: 'dataDictionary',
            meta: { title: '数据字典管理' },
            component: () => import('../views/system/dataDictionary')
          },
          {
            path: '/system/schoolInformation',
            name: 'schoolInformation',
            meta: { title: '学校信息管理' },
            component: () => import('../views/system/schoolInformation')
          },
          {
            path: '/system/departmentInformation',
            name: 'departmentInformation',
            meta: { title: '系室信息管理' },
            component: () => import('../views/system/departmentInformation')
          },
          {
            path: '/system/progessionalInformation',
            name: 'progessionalInformation',
            meta: { title: '专业信息管理' },
            component: () => import('../views/system/progessionalInformation')
          },
          {
            path: '/system/classInformation',
            name: 'classInformation',
            meta: { title: '班级信息管理' },
            component: () => import('../views/system/classInformation')
          },
          {
            path: '/system/systemFimctopm',
            name: 'systemFimctopm',
            meta: { title: '系统功能管理' },
            component: () => import('../views/system/systemFimctopm')
          },
          {
            path: '/system/systemLog',
            name: 'systemLog',
            meta: { title: '系统日志管理' },
            component: () => import('../views/system/systemLog')
          },
          {
            path: '/system/exSteps',
            name: 'exSteps',
            meta: { title: '实验步骤管理' },
            component: () => import('../views/system/exSteps/index.vue')
          }
        ]
      },
      //权限管理
      {
        path: '/jurisdiction/role',
        name: 'jurisdiction',
        meta: { title: '权限管理' },
        redirect: '/jurisdiction/role',
        component: RouteView,
        children: [
          {
            path: '/jurisdiction/role',
            name: 'role',
            meta: { title: '角色管理' },
            component: () => import('../views/jurisdiction/role')
          },
          {
            path: '/jurisdiction/user',
            name: 'user',
            meta: { title: '用户管理' },
            component: () => import('../views/jurisdiction/user')
          },
          {
            path: '/jurisdiction/expAuthority',
            name: 'expAuthority',
            meta: { title: '实验权限管理' },
            component: () => import('../views/jurisdiction/expAuthority')
          },
          {
            path: '/jurisdiction/unifiedEvaluation',
            name: 'unifiedEvaluation',
            meta: { title: '统一测评参数管理' },
            component: () => import('../views/jurisdiction/unifiedEvaluation')
          }
        ]
      },
      //门户管理
      {
        path: '/door/notice',
        name: 'door',
        meta: { title: '门户管理' },
        redirect: '/door/notice',
        component: RouteView,
        children: [
          {
            path: '/door/notice',
            name: 'notice',
            meta: { title: '公告管理' },
            component: () => import('../views/door/notice')
          },
          {
            path: '/door/journalism',
            name: 'journalism',
            meta: { title: '新闻管理' },
            component: () => import('../views/door/journalism')
          },
          {
            path: '/door/article',
            name: 'article',
            meta: { title: '文章管理' },
            redirect: '/door/article/list',
            component: () => import('../views/door/article'),
            children: [
              {
                path: '/door/article/list',
                name: 'articlelist',
                meta: { title: '文章列表' },
                component: () => import('../views/door/article/List.vue')
              },
              {
                path: '/door/article/edit',
                name: 'articleedit',
                meta: { title: '编辑文章' },
                component: () => import('../views/door/article/ModifyArtical.vue')
              }
            ]
          },

          {
            path: '/door/feedback',
            name: 'feedback',
            meta: { title: '反馈建议管理' },
            component: () => import('../views/door/feedback')
          }
        ]
      },
      //管理中心
      {
        path: '/management/taseNotes',
        name: 'management',
        meta: { title: '管理中心' },
        redirect: '/management/taseNotes',
        component: RouteView,
        children: [
          {
            path: '/management/taseNotes',
            name: 'taseNotes',
            meta: { title: '课程学习记录' },
            component: () => import('../views/management/taseNotes')
          },
          {
            path: '/management/expOperation',
            name: 'expOperation',
            meta: { title: '实验操作记录' },
            component: () => import('../views/management/expOperation')
          },
          {
            path: '/management/teacherPublish',
            name: 'teacherPublish',
            meta: { title: '实验考核发布记录' },
            component: () => import('../views/management/teacherPublish')
          },
          {
            path: '/management/testQuestions',
            name: 'testQuestions',
            meta: { title: '实验考核记录' },
            component: () => import('../views/management/testQuestions')
          },
          {
            path: '/management/expExamineRecord',
            name: 'expExamineRecord',
            meta: { title: '实验考核记录' },
            component: () => import('../views/management/expExamineRecord')
          },
          {
            path: '/management/visualizationManage',
            name: 'visualizationManage',
            meta: { title: '可视化大屏管理' },
            component: () => import('../views/management/visualizationManage')
          },
          {
            path: '/management/testExamine',
            name: 'testExamine',
            meta: { title: '试题审核记录' },
            component: () => import('../views/management/testExamine')
          },
          {
            path: '/management/classExperSumData',
            name: 'classExperSumData',
            meta: { title: '班级实验汇总' },
            component: () => import('../views/management/classExperSumData')
          },
          {
            path: '/management/semesterManagement',
            name: 'semesterManagement',
            meta: { title: '学期管理' },
            component: () => import('../views/management/semesterManagement')
          }
        ]
      },
      //统计中心
      {
        path: '/statistics/expStatistics',
        name: 'statistics',
        meta: { title: '统计中心' },
        redirect: '/statistics/expStatistics',
        component: RouteView,
        children: [
          {
            path: '/statistics/expStatistics',
            name: 'expStatistics',
            meta: { title: '实验统计' },
            component: () => import('../views/statistics/expStatistics')
          },
          {
            path: '/statistics/stepSum',
            name: 'stepSum',
            meta: { title: '实验步骤' },
            component: () => import('../views/statistics/stepSum')
          },
          {
            path: '/statistics/checkStatistics',
            name: 'checkStatistics',
            meta: { title: '试题考核统计' },
            component: () => import('../views/statistics/checkStatistics')
          },
          {
            path: '/statistics/assessStatistics',
            name: 'assessStatistics',
            meta: { title: '测评统计' },
            component: () => import('../views/statistics/assessStatistics')
          }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/') return next()
  const tokenStr = localStorage.getItem('token')
  if (!tokenStr) return next('/')
  next()
})

export default router
